import React, { useEffect, useState } from "react";
import { getFilteredPosts } from "../services/posts.services";
import { formatDateMDDYYYY } from "../utils/Date.util";
import BlogStyle3 from "./BlogStyle3";

const HomeMainSection = () => {
    const [mainSectionPosts, setMainSectionPosts] = useState(null);

    const fetchPostsMainSection = async () => {
        const response = await getFilteredPosts({ to_date: Date.now() });
        if (response.length > 0) {
            console.log(response.slice(0, 5));
            setMainSectionPosts(response.slice(0, 5));
        } else {
            setMainSectionPosts([]);
        }
    };

    useEffect(() => {
        fetchPostsMainSection();
    }, []);

    if (!mainSectionPosts) {
        return (
            <section className="space">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 mb-4 mb-xl-0">
                            <div className="row gy-4" style={{ height: "100%" }}>
                                <div
                                    className="dark-theme img-overlay2"
                                    style={{ height: "100%" }}
                                >
                                    <BlogStyle3 skeleton={true}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="row gy-4">
                                <div className="col-xl-6 col-md-6 dark-theme img-overlay2">
                                    <BlogStyle3 skeleton={true}/>
                                </div>
                                <div className="col-xl-6 col-md-6 dark-theme img-overlay2">
                                    <BlogStyle3 skeleton={true}/>
                                </div>
                                <div className="col-xl-6 col-md-6 dark-theme img-overlay2">
                                    <BlogStyle3 skeleton={true}/>
                                </div>
                                <div className="col-xl-6 col-md-6 dark-theme img-overlay2">
                                    <BlogStyle3 skeleton={true}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (mainSectionPosts.length === 0) {
        return null;
    }

    return (
        <section className="space">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 mb-4 mb-xl-0">
                        <div className="row gy-4" style={{ height: "100%" }}>
                            <div
                                className="dark-theme img-overlay2"
                                style={{ height: "100%" }}
                            >
                                <BlogStyle3 post={mainSectionPosts[0]} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="row gy-4">
                            <div className="col-xl-6 col-md-6 dark-theme img-overlay2">
                                <BlogStyle3 post={mainSectionPosts[1]} />
                            </div>
                            <div className="col-xl-6 col-md-6 dark-theme img-overlay2">
                                <BlogStyle3 post={mainSectionPosts[2]} />
                            </div>
                            <div className="col-xl-6 col-md-6 dark-theme img-overlay2">
                                <BlogStyle3 post={mainSectionPosts[3]} />
                            </div>
                            <div className="col-xl-6 col-md-6 dark-theme img-overlay2">
                                <BlogStyle3 post={mainSectionPosts[4]} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeMainSection;
